/** Eternal City copy, pl. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityPl: Record<string, string> = {
  'city.seoDescription': 'Wchodź do żywego miasta. Każdy zachowuje codzienny zwyczaj. Idź za nimi, rozmawiaj z nimi i spędz z ludźmi, którzy bez ciebie żyją.',
  'city.intro': 'Każdy tu zachowuje codzienną rutynę, a czas minie, gdy grasz.',
  'city.back': 'Wracamy do świata.',
  'city.connecting': 'Otwierając bramy miasta...',
  'city.reconnecting': 'Zgubiłem wątek.',
  'city.offline': 'Miasto jest teraz poza zasięgiem.',
  'city.signinTitle': 'Zapisz się , aby wejść .',
  'city.signinBody': 'Twoje miejsce w mieście, twoje dziennik i ludzie, których spotkałeś, są zapisane na twoje konto.',
  'city.signinCta': 'Zapisz się .',
  'city.privacy': 'Jak obsługujemy te dane: Polityka prywatności',
  'city.blocked': 'Jeśli uważasz, że to błąd, skontaktuj się z wsparciem.',
  'city.openElsewhere': 'To miasto jest otwarte w innej sekcji.',
  'city.canvasLabel': 'Mapy izometryczne {city}. Użyj listy obok, żeby porozmawiać, chodzić i rozejrzeć się.',
  'city.hint': 'Kliknij na ziemię, aby chodzić, lub kliknij na osobę, aby porozmawiać.',
  'city.holiday': 'Dziś: {name}',
  'city.here': 'Jesteś w {place}.',
  'city.commons.empty': 'To wspólna przestrzeń, a teraz nie ma tu innych podróżnych.',
  'city.commons.here.one': 'To wspólna przestrzeń, a tu jest jeszcze jeden podróżnik.',
  'city.commons.here.other': 'To wspólna przestrzeń. {count} Są tu inni podróżnicy.',
  'city.commons.peer': 'towarzysza podróżnika',
  'city.crowd.name': 'Mieszkańcy miasta',
  'city.travel.ride': 'Jeździć do {place} (około {n} Minutki)',
  'city.wares.now': 'Teraz to wyjaśniono: {list}',
  'city.wares.none': 'Nic nie jest w tej godzinie.',
  'city.wares.few': '{name} (po kilku pozostałych)',
  'city.wares.last': '{name} (ostatni)',
  'city.places': 'Idź gdzieś.',
  'city.goPlace': 'Idź do {place}',
  'city.dialogueAnnounce': 'Wybory są ogłaszane tak, jak się pojawiają.',
  'city.people': 'Kto jest w pobliżu',
  'city.peopleNone': 'Nikogo widocznego.',
  'city.talk': 'Rozmawiaj.',
  'city.goto': 'Przejdźmy.',
  'city.away': '{n} kroki wstecz',
  'city.scenes': 'To się dzieje w pobliżu.',
  'city.watch': 'Dołącz do nas .',
  'city.props': 'Rozejrzyj się.',
  'city.examine': 'Patrzcie.',
  'city.open': 'Otwarte',
  'city.take': 'Weź to .',
  'city.menu.open': 'Otwarte {thing}',
  'city.menu.take': 'Weź to , co jest w środku . {thing}',
  'city.menu.walkToThing': 'Idź do niego. {thing}',
  'city.dialogue': 'Rozmowa',
  'city.close': '/Zbliża się',
  'city.leave': 'Zostaw rozmowę.',
  'city.menu.talk': 'Rozmawiaj z {name}',
  'city.menu.walkTalk': 'Chodź do mnie. {name}',
  'city.menu.walkTo': 'Idź do niego. {name}',
  'city.menu.walkHere': 'Chodź tutaj.',
  'city.menu.swimHere': 'Pływaj tutaj.',
  'city.menu.rowHere': 'Rzuć się tutaj.',
  'city.mount.down': 'Zejdźcie. {name}',
  'city.companion.home': 'Wysyłaj {name} w domu',
  'city.rumours.title': 'Tablica pogłosków',
  'city.rumours.none': 'Stoją w pobliżu mieszkańców miasta, rozmawiają razem, przede wszystkim w tawernie, a to, co mówią, jest tu przypięte.',
  'city.rumours.said': 'Powiedział: {name}',
  'city.greet.title': 'Znany po imieniu',
  'city.greet.callMe': 'Jak ci mówią mieszkańcy miasta?',
  'city.greet.placeholder': 'Jak się nazywasz?',
  'city.greet.none': 'Nikt cię jeszcze nie zna. Zatrzymaj się i porozmawiaj z kimś, a następnym razem pozdrowi cię po imieniu.',
  'city.greet.morning.0': 'Dzień dobry. {name}!',
  'city.greet.morning.1': 'Dzień dobry. {name}.',
  'city.greet.morning.2': 'Wstałem wcześnie. {name}?',
  'city.greet.afternoon.0': 'Dzień dobry. {name}.',
  'city.greet.afternoon.1': 'Dzień dobry. {name}!',
  'city.greet.afternoon.2': 'Dobrze się znów poznaliśmy. {name}.',
  'city.greet.evening.0': 'Wieczorem, {name}.',
  'city.greet.evening.1': 'Dobry wieczór. {name}!',
  'city.greet.evening.2': 'W domu. {name}?',
  'city.greet.night.0': 'Spóźniłem się na wyjście. {name}.',
  'city.greet.night.1': 'Uważaj na ciemność. {name}.',
  'city.greet.night.2': 'Wciąż chodzi o... {name}?',
  'city.greet.morning.0.anon': 'Dzień dobry, przyjacielu!',
  'city.greet.morning.1.anon': 'Dzień dobry.',
  'city.greet.morning.2.anon': 'Wstałeś wcześnie, przyjacielu?',
  'city.greet.afternoon.0.anon': 'Dzień dobry, przyjacielu.',
  'city.greet.afternoon.1.anon': 'Dzień dobry!',
  'city.greet.afternoon.2.anon': 'Dobrze, że się znów spotkaliśmy.',
  'city.greet.evening.0.anon': 'Wieczorem, przyjacielu.',
  'city.greet.evening.1.anon': 'Dobry wieczór!',
  'city.greet.evening.2.anon': 'W domu, przyjacielu?',
  'city.greet.night.0.anon': 'Za późno na wyjście, przyjacielu.',
  'city.greet.night.1.anon': 'Uważaj na ciemność.',
  'city.greet.night.2.anon': 'Nadal jesteś, przyjacielu?',
  'city.market.title': 'Rynkowa tablica',
  'city.market.shut': 'Nic teraz nie jest.',
  'city.market.later': 'Później dzisiaj:',
  'city.market.am': '{n} Rano',
  'city.market.pm': '{n} Po południu',
  'city.market.eve': '{n} wieczorem.',
  'city.garden.title': 'Powierzchnie ogrodowe',
  'city.garden.tend': 'Opiekuj plotkę.',
  'city.garden.tended': 'Wyciągnij kilka traw i napoj działkę.',
  'city.garden.already': 'Już dziś się tym zajmowałeś.',
  'city.garden.tendedNote': 'Dziś.',
  'city.garden.arrive': 'Wydarzenie {crop} Oto... {stage}.',
  'city.garden.crop.herbs': 'rośliny',
  'city.garden.crop.apples': 'drzewa jabłkowe',
  'city.garden.crop.kitchen': 'zieleni z kuchni',
  'city.garden.crop.cabbages': 'kapusty i fasola',
  'city.garden.crop.wheat': 'pola pszenicy',
  'city.garden.stage.bare': 'Gość na zimę',
  'city.garden.stage.sown': 'świeżo zasiewane',
  'city.garden.stage.sprouting': 'rozkwitające',
  'city.garden.stage.growing': 'dobrze rosnące',
  'city.garden.stage.flowering': 'w kwiat',
  'city.garden.stage.ripe': 'gotowe i dojrzałe',
  'city.garden.stage.harvested': 'zbiorów za rok',
  'city.fish.title': 'Rybactwo',
  'city.fish.cast': 'Wyrzuć linię',
  'city.fish.go': 'Idź.',
  'city.fish.here': 'Dobry miejsce do połowów.',
  'city.fish.casting': 'Wyrzuć linię i poczekaj.',
  'city.fish.caught': 'Coś cię ugryzie. {fish}.',
  'city.fish.got.boot': 'Wciągasz stary but i wrzucasz go z powrotem.',
  'city.fish.got.weed': 'Tym razem tylko trawa rzeki.',
  'city.fish.got.nothing': 'Woda zachowuje swoje sekrety.',
  'city.fish.casts': '{n} rzuca do tej pory',
  'city.fish.none': 'Ryby ugryzły najlepiej o świcie i zmierzchu, a więcej wiosną i jesienią.',
  'city.fish.spot.bank': 'brzeg rzeki',
  'city.fish.spot.jetty': 'żetwy',
  'city.fish.spot.bridge': 'most młynowy',
  'city.fish.name.perch': 'węgiel',
  'city.fish.name.roach': 'szczura',
  'city.fish.name.trout': 'Pstrąga',
  'city.fish.name.eel': 'orzecha',
  'city.fish.name.pike': 'szczura',
  'city.fish.name.carp': 'karpę',
  'city.fish.name.minnow': 'wędrowna',
  'city.fish.name.crayfish': 'żółtka',
  'city.fish.name.boot': 'stary but',
  'city.fish.name.weed': 'trawy rzeki',
  'city.fish.name.nothing': 'Niczego.',
  'city.lost.title': 'Zgubione i odnalezione',
  'city.lost.none': 'Mieszkańcy miasta rzucają rzeczy na rynkach, na placach i na innych miejscach, kiedy stoisz tam, gdzie coś leży, weź je tutaj.',
  'city.lost.whose': 'należy do {name}',
  'city.lost.find': 'Znajdź {name}',
  'city.lost.spot': 'Coś tu leży na ziemi: {thing}',
  'city.lost.pick': 'Odbierz . {thing}',
  'city.lost.picked': 'Odbierz. {thing}. Wygląda na to , że należy do {name}.',
  'city.lost.give': 'Dawać {thing} Wracając do {name}',
  'city.lost.thanks': '{name} Cieszę się, że {thing} Wracaj.',
  'city.lost.thing.glove': 'Zagubiona rękawiczka',
  'city.lost.thing.keys': 'Pierścień kluczy',
  'city.lost.thing.locket': 'Mały medalion.',
  'city.lost.thing.toy': 'drewniana zabawka',
  'city.lost.thing.scarf': 'szarf wełniany',
  'city.lost.thing.purse': 'pusty portfel',
  'city.lost.thing.spectacles': 'parę okularów.',
  'city.lost.thing.letter': 'Pisząc list',
  'city.lost.thing.ribbon': 'węzeł do włosów',
  'city.lost.thing.pipe': 'rury z gliny',
  'city.records.title': 'Rejestry miast',
  'city.records.peak': 'Najczęściej dzisiaj w {time}, wraz z {n} Mieszkańcy miasta.',
  'city.records.now': 'O tej godzinie: {out} na zewnątrz, {home} w domu.',
  'city.records.busiest': 'Najczęstszego kwartału: {district}.',
  'city.records.outTitle': 'Mieszkańcy miasta, na godzinę.',
  'city.records.seenTitle': 'Ludzie, których widziałeś wokół siebie, na godzinę',
  'city.a11y.title': 'Dostępność',
  'city.a11y.text': 'Wielkość tekstu',
  'city.a11y.size1': 'Normalne',
  'city.a11y.size125': 'Wielkie',
  'city.a11y.size15': 'Największe',
  'city.a11y.stillOff': 'Zmniejszenie ruchu',
  'city.a11y.stillOn': 'Zmniejszenie wniosku',
  'city.a11y.contrastOff': 'Wysoki kontrast',
  'city.a11y.contrastOn': 'Wysoki kontrast',
  'city.tour.welcome.title': 'Witamy w {city}',
  'city.tour.welcome.body': 'To miasto żyje na własnym zegarze. Ludzie budzą się, pracują, jedzą i śpią, czy patrzysz czy nie.',
  'city.tour.walk.title': 'Spacer',
  'city.tour.walk.body': 'Wykorzystaj wszelką otwartą ziemię, aby tam iść.',
  'city.tour.talk.title': 'Rozmawiamy.',
  'city.tour.talk.body': 'Naciskaj, aby zobaczyć nazwisko osoby i przejdź do niej.',
  'city.tour.menu.title': 'Patrząc bliżej',
  'city.tour.menu.body': 'Na komputerze kliknij prawym kliknięciem na cokolwiek, aby zobaczyć, co możesz tam zrobić, np. czytać znak, usiąść lub wziąć pokój.',
  'city.tour.map.title': 'Minimalna mapa',
  'city.tour.map.body': 'Mała mapa w rogu pokazuje drogi, dzielnice i ludzi w pobliżu.',
  'city.tour.panel.title': 'Twój panel',
  'city.tour.panel.body': 'Panel boczny zawiera listę ludzi w pobliżu, miejsc, które odkryłeś, swoich zadań, dziennika i wiele innych.',
  'city.tour.keys.title': 'Przejście',
  'city.tour.keys.body': 'Przycisek na klawiaturze pokazuje każdy ruch robota.',
  'city.tour.done.title': 'To wszystko.',
  'city.tour.done.body': 'Ciesz się . {city}. Możesz zrobić tę trasę ponownie z panelu bocznego.',
  'city.tour.step': '{n} z {total}',
  'city.tour.next': 'Następny',
  'city.tour.back': 'Wracając',
  'city.tour.skip': 'Przejmij wycieczkę .',
  'city.tour.finish': 'Zacznij odkrywać.',
  'city.tour.again': 'Znowu zwiedzamy miasto.',
  'city.found.title': 'Odkryte miejsca',
  'city.found.count': '{n} z {total}',
  'city.found.none': 'Wchodź do miejsca, gdzie możesz to dodać.',
  'city.found.new': 'Odkryte {place}',
  'city.board.open': 'Przeczytaj publiczną tablicę notatek',
  'city.board.hint': 'Przypiśnij sobie krótką, bez linków, a do trzech pozostać jednocześnie.',
  'city.board.placeholder': 'Napisz krótką notatkę, żeby inni ją znaleźli.',
  'city.board.pin': 'Przywiąż notatkę.',
  'city.board.loading': 'Czytając tablicę...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Zapisz notatkę.',
  'city.board.err.signin': 'Zapisz się, żeby zapisać notatkę.',
  'city.board.err.soon': 'Poczekaj chwilę, zanim przyłożę kolejną notatkę.',
  'city.board.err.bad': 'Notatki muszą być tekstem prostym do 200 znaków, bez linków.',
  'city.board.err.down': 'Zarząd nie jest teraz w zasięgu.',
  'city.room.rent': 'Zatrzymaj pokój w {place}',
  'city.room.move': 'Przenieś swój pokój do {place}',
  'city.room.yours': 'Twój pokój w {place}',
  'city.room.decorate': 'Zrób coś tutaj.',
  'city.room.remove': 'Zabierz to . {thing}',
  'city.room.leave': 'Oddaj swój pokój.',
  'city.room.full': 'Twój pokój nie ma miejsca na więcej.',
  'city.room.pickTitle': 'Przygotuj swój pokój.',
  'city.room.pickHint': 'Wybierz coś na tym miejscu, które pozostanie w twoim pokoju.',
  'city.room.kind.rug': 'Tkaniec z tkaniny',
  'city.room.kind.candle': 'Świeca.',
  'city.room.kind.flowers': 'Węża kwiatów',
  'city.room.kind.painting': 'Obraz',
  'city.room.kind.plant': 'Roślina w słoiku',
  'city.room.kind.chest': 'Mała klatka piersiowa',
  'city.room.kind.lantern': 'Światła',
  'city.room.kind.books': 'Kilka książek.',
  'city.busk.lute': '{name} /wyciąga jasną melodię /w pobliżu',
  'city.busk.fiddle': '{name} wyciąga w pobliżu żywy bębny',
  'city.busk.pipe': '{name} gra powoli powietrze w pobliżu',
  'city.busk.drum': '{name} /wybija taniec w pobliżu',
  'city.tail.label': 'Następne {name}',
  'city.tail.title': 'Wyrzucanie {name} Przez cały dzień',
  'city.tail.now': 'A teraz: {activity} w {place}',
  'city.tail.unknown': 'Ich plany są nieznane.',
  'city.tail.next': 'Następny: {place} w {time}, w {h} h {m} min.',
  'city.tail.trail': '/Przeszliśmy przez: {places}',
  'city.tail.stop': 'Przestań śledzić.',
  'city.pins.add': 'Dodaj szczotkę',
  'city.pins.tapMap': 'Kliknij na mapę , aby umieścić sztylet',
  'city.pins.walk': 'Chodź do tego szczelnika.',
  'city.pins.note': 'Przycisnąć {x}, {y}. Dodaj notatkę .',
  'city.pins.noteLabel': 'Wpis do przycisku',
  'city.pins.remove': 'Zdejmij ten sztylet.',
  'city.pins.here': 'Przyknij to miejsce na mapie.',
  'city.compass.north': 'Północ',
  'city.compass.at': 'x {x}, y {y}, podłogę {floor}',
  'city.door.prop': 'Otwórz drzwi.',
  'city.door.close': 'Niech drzwi się zamkną.',
  'city.door.unlock': 'Otwórz drzwi .',
  'city.door.lock': 'Zamknij drzwi.',
  'city.books.browse': 'Przeglądaj półkę',
  'city.books.shelf': 'Na półce w {place}',
  'city.books.book': 'Książka',
  'city.books.scroll': 'Wykręty',
  'city.books.prev': 'Poprzedni',
  'city.books.back': 'Wracaj do półki.',
  'city.books.next': 'Następny',
  'city.books.page': 'Strona {n} {of}',
  'city.sign.readSign': 'Przeczytaj znak .',
  'city.sign.readPlaque': 'Przeczytaj płytkę',
  'city.sign.sign': 'Malowany znak',
  'city.sign.plaque': 'Plaka przy drzwiach',
  'city.district.entering': 'Teraz wchodzimy .',
  'city.district.riverside': 'Na brzegu rzeki i na niskich rynkach',
  'city.district.sunwalk': 'Sunwalk',
  'city.district.lanes': '/Przewodniki /',
  'city.district.monastery': 'Klasztor',
  'city.district.castle': 'Zamek',
  'city.district.drains': 'Stare kanały',
  'city.district.farmlands': 'Ziemi rolnicze',
  'city.photo.enter': 'Tryb zdjęcia',
  'city.photo.hint': 'W trybie zdjęcia. Przeciągnij, aby obejrzeć się, zrobi zdjęcie ekranu, aby je zachować.',
  'city.photo.leave': 'Wystąpienie w trybie zdjęcia',
  'city.building.who': 'Kto mieszka i pracuje w {place}',
  'city.building.live': 'Mieszka tutaj.',
  'city.building.work': 'Pracuje tutaj.',
  'city.building.now': 'W środku.',
  'city.building.rooms': '/Wstępuje {list}.',
  'city.inspect.about': 'O {name}',
  'city.inspect.close': '/Zbliża się',
  'city.inspect.unknown': 'Nikt nie może powiedzieć ci wiele o {name}.',
  'city.inspect.home': 'Dom',
  'city.inspect.work': 'Praca',
  'city.inspect.none': 'Żaden nie znany',
  'city.inspect.today': 'Dziś',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Idź za mną. {name} Przez cały dzień',
  'city.overlay.label': 'Płyty mapy',
  'city.overlay.crowd': '/Ludzie',
  'city.overlay.light': 'Światło',
  'city.overlay.noise': 'Hałas',
  'city.bar.pop': '{n} Mieszkaj tutaj.',
  'city.bar.out': '{n} Wyjdź teraz.',
  'city.bar.season.spring': 'Wiosna',
  'city.bar.season.summer': 'Latem',
  'city.bar.season.autumn': 'Jesień',
  'city.bar.season.winter': 'Zima',
  'city.notebook.title': 'Słyszałem i nauczyłem się',
  'city.notebook.all': 'Wszystkie .',
  'city.notebook.heard': 'Słyszałem .',
  'city.notebook.learned': 'Nauczony',
  'city.notebook.search': 'Sprawdź notatki.',
  'city.notebook.none': '/Nigdy nie zauważyłem.',
  'city.ask.title': 'Zapytaj się .',
  'city.ask.pick': '- Kogo szukasz?',
  'city.ask.ask': 'Zapytaj .',
  'city.ask.passerby': 'Przechodzący',
  'city.ask.nobody': 'Nie ma nikogo na tyle bliskiego, by zapytać.',
  'city.ask.unseen': '{asker} nie widział {who} O dzisiejszym dniu.',
  'city.ask.here': '{asker} mówi {who} Jest blisko. {place}.',
  'city.ask.go': 'Idź do {who}',
  'city.weather.clear': 'Jasne niebo',
  'city.weather.cloudy.light': 'Kilka chmur.',
  'city.weather.cloudy.heavy': 'Szary i obłokły',
  'city.weather.rain.light': 'Mały deszcz',
  'city.weather.rain.heavy': 'Silny deszcz',
  'city.weather.fog.light': 'Rano mgła',
  'city.weather.fog.heavy': 'Gęsta mgła',
  'city.weather.snow.light': 'Śnieg lekki',
  'city.weather.snow.heavy': 'Ciężka śnieg',
  'city.lamplighter.name': 'Światło',
  'city.lamplighter.lighting': 'oświetlenie lamp ulicznych',
  'city.lamplighter.dousing': 'Wyłączając lampy uliczne',
  'city.hourglass.title': 'Zegarek piaskowy',
  'city.hourglass.stop': 'Zatrzymaj dzień.',
  'city.hourglass.paused': 'Dzień się zatrzymał.',
  'city.hourglass.resume': 'Idź dalej.',
  'city.seat.bench': 'ławka',
  'city.seat.chair': 'krzesło',
  'city.seat.sit': 'Siadaj na {what}',
  'city.inside.crate': 'skrzynka',
  'city.inside.barrel': 'barel',
  'city.inside.title': 'W środku {what}',
  'city.inside.look': 'Spójrz w {what}',
  'city.inside.holds': 'To jest {fill}: {list}.',
  'city.factions.title': 'Stojąc w mieście',
  'city.factions.wary': '/Wystrzegaj się',
  'city.factions.unknown': 'Nieznane',
  'city.factions.noticed': 'Zauważone',
  'city.factions.trusted': 'Zaufanie',
  'city.factions.honored': '/Pracowany',
  'city.factions.done': 'Zarealizowane: {n}.',
  'city.mail.title': 'Listy',
  'city.mail.none': 'Jeszcze nie ma listów.',
  'city.mail.from': 'Od: {name}',
  'city.mail.waiting': 'Czekam na odpowiedź od {names}.',
  'city.mail.nobody': 'Pomóż komuś z zadaniem i możesz napisać do niego.',
  'city.mail.write': 'Napisz list.',
  'city.mail.to': 'Do kogo?',
  'city.mail.subject': 'Przedmiot',
  'city.mail.body': 'Twoje listy',
  'city.mail.send': 'Wyślij to .',
  'city.mail.untitled': 'Kilka linii .',
  'city.moth.title': 'Płytka Moty',
  'city.moth.trade': 'Zrób mi przysługę.',
  'city.moth.yours': 'Teraz twoja.',
  'city.spy.title': 'Cicha praca',
  'city.cut.skip': 'Przejść',
  'city.party.title': 'Zagraj razem.',
  'city.party.blurb': 'Zacznij imprezę i podziel się jej kodem z przyjaciółmi.',
  'city.party.start': 'Zacznij imprezę.',
  'city.party.codeLabel': 'Kod imprezy',
  'city.party.join': 'Dołącz',
  'city.party.bad': 'Kod imprezy składa się z czterech do ośmiu liter lub liczb.',
  'city.party.code': 'Twój kod imprezy jest: {code}. Podziel się tym z przyjaciółmi, żeby mogli dołączyć.',
  'city.party.alone': 'Nikt z twojej partii nie jest w mieście.',
  'city.party.here': 'Tuż obok ciebie.',
  'city.party.away': '{n} kroki {dir}',
  'city.party.floor': '(podłogę) {n})',
  'city.party.go': 'Idź do',
  'city.party.leave': 'Zostawcie imprezę.',
  'city.party.dir.east': 'wschód',
  'city.party.dir.south-east': 'południowo-wschodni',
  'city.party.dir.south': 'południowy',
  'city.party.dir.south-west': 'południowo-zachodni',
  'city.party.dir.west': 'Zachód',
  'city.party.dir.north-west': 'północno-zachodni',
  'city.party.dir.north': 'północ',
  'city.party.dir.north-east': 'północno-wschodni',
  'city.print.title': 'Drukuj budynek',
  'city.print.here': '{name}: {w} przez: {d} komórki, podłogi: {n}. Zachowaj go jako STL dla drukarki 3D.',
  'city.print.none': 'Stać w budynku lub obok budynku, aby zapisać go jako STL dla drukarki 3D.',
  'city.print.model': 'Przechowywanie STL, skala modelu (5 mm na komórkę)',
  'city.print.tabletop': 'Zapisz STL, skala stołowa (1 cm na komórkę)',
  'city.print.note': 'Ściany, podłogi, drzwi, schody i okna, gdy miasto je rysuje, na płytce bazowej, tak że drukuje w jednym kawałku.',
  'city.print.models': 'Figury i rekwizyty, gotowe do drukowania:',
  'city.print.busy': 'Przygotowuję...',
  'city.print.model.figure': 'Figura Walker, 28 mm na bazie 25 mm',
  'city.print.model.fountain': 'Fountain, 3 cali w szerokości',
  'city.print.model.castle-wall': 'Sekcja ściany zamku, długość 3 cali',
  'city.editor.stl': 'Zapisz STL',
  'city.editor.title': 'Redaktor mapy miasta',
  'city.editor.blurb': 'Pomaluj mapę miasta podłogiem po podłodze: ściany, ulice, drzwi, woda, drabinki i nazwane miejsca.',
  'city.editor.name': 'Nazwa mapy',
  'city.editor.tools': 'Narzędzia',
  'city.editor.tool.pen': 'Pióro',
  'city.editor.tool.rect': 'Blok',
  'city.editor.tool.room': 'Pokój',
  'city.editor.tool.fill': 'Wypełnienie',
  'city.editor.tool.spawn': 'Punkt wyjścia',
  'city.editor.tiles': 'Poziom',
  'city.editor.letter': 'List',
  'city.editor.placeName': 'Nazwa miejsca',
  'city.editor.addPlace': 'Dodaj miejsce',
  'city.editor.placeBad': 'Miejsce potrzebuje jednej litery i nazwy.',
  'city.editor.floors': 'Podłogi',
  'city.editor.addFloor': 'Dodatek podłogi',
  'city.editor.map': 'Mapa',
  'city.editor.width': 'Szerokość',
  'city.editor.height': 'Wysokość',
  'city.editor.new': 'Nowa mapa',
  'city.editor.undo': 'Nieważne',
  'city.editor.export': 'Eksport',
  'city.editor.import': 'Importacja',
  'city.editor.loaded': 'Mapy załadowane.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'Sprawdź',
  'city.editor.ok': 'Czyta się czysto. {walk} otwarte komórki, {reach} dostępne od punktu wyjścia.',
  'city.editor.placeSpots': '{name}: {n} komórki',
  'city.editor.canvas': 'Płyta mapy',
  'city.spy.take': 'Weź to .',
  'city.spy.again': 'Spróbuj jeszcze raz.',
  'city.spy.drop': 'Zostaw to.',
  'city.spy.progress': '{n} procent tam.',
  'city.spy.carrying': 'Masz notatkę.',
  'city.spy.underway': 'W drodze.',
  'city.spy.done': 'Zakończyłem.',
  'city.spy.failed': 'Ostatnim razem poszło źle.',
  'city.menu.look': 'Patrzcie na to. {thing}',
  'city.menu.street': 'Ulica',
  'city.menu.wall': 'Ściana',
  'city.continue': 'Kontynuuj',
  'city.goodbye': 'Żegnajcie .',
  'city.board.title': 'Tablica nagród',
  'city.arrive.rooftops': 'Wyciągasz się na dachy, a pod tobą otwierają się pasy, a pod nogami kręcają deski między domami.',
  'city.arrive.museumRoof': 'Wciągasz się na dach muzeum, a Sunwalk Plaza rozciąga się pod tobą jak tablica.',
  'city.crier.title': 'Płytka płytka',
  'city.crier.today': 'Dziś jest {name}.',
  'city.crier.tomorrow': '{name} To jutro.',
  'city.crier.coming': '{name} w {n} Dni.',
  'city.crier.stalls': 'Na stacjach przy pierwszym świcie:',
  'city.crier.notices': '{n} /Powiadomienia na tablicy nagród.',
  'city.crier.talk': 'Mówiąc o mieście:',
  'city.crier.now': 'To co dzieje się w mieście:',
  'city.board.empty': 'Nic dzisiaj nie jest zamknięte, sprawdź jutro.',
  'city.board.posted': 'Publikowane przez: {name}.',
  'city.board.postedAt': 'Publikowane przez: {name}, teraz w {place}.',
  'city.board.days': '{n} Zostanie kilka dni.',
  'city.board.find': 'Znajdź ich.',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Rozmawiamy z {name}',
  'city.journal': 'Dziennik',
  'city.journalNone': 'Jeszcze nic nie zostało napisane.',
  'city.quests': 'Płytki i włókna',
  'city.questNone': 'Jeszcze nie, rozmawiaj z ludźmi.',
  'city.rest': 'Odpoczynek {n} minuty',
  'city.saves.title': 'Zaoszczędzone gry',
  'city.saves.slot': 'Słotka {n}: {day} {time}, {place}',
  'city.saves.empty': 'Słotka {n}: pusta',
  'city.saves.save': 'Zachowaj tutaj.',
  'city.saves.load': 'Obciążenie',
  'city.saves.sure': 'Kliknij ponownie , aby potwierdzić',
  'city.saves.hint': 'Oszczędzenie utrzymuje całe miasto tak, jak jest: gdzie jesteś, godzina, ludzie, misje i skrzydła.',
  'city.restHint': 'Pozwól mi upłynąć czas.',
  'city.bed.ask': 'Śpij w środku. {bed}?',
  'city.bed.night': 'Osiem godzin przechodzi, kiedy śpisz i odpoczywasz zgodnie z zasadami swojego systemu gry.',
  'city.bed.sleep': 'Śpij',
  'city.bed.notNow': 'Nie teraz.',
  'city.bed.tired': 'Nie jesteś jeszcze zmęczony. {n} - godzinami.',
  'city.bed.asleep': 'Śpią, przechodzi noc...',
  'city.bed.offer': 'Spać tutaj.',
  'city.vitals': 'Zdrowie',
  'city.bed.woke': 'Ty śpisz w {bed} i obudzić się w {time}. {change}',
  'city.bed.change': '{label}: {before} do {after}.',
  'city.bed.noRest': 'Wydarzenie {system} Zasady nie dają odzyskania odpoczynku, więc nic się nie naprawi.',
  'city.bed.beds': 'Łóżki',
  'city.bed.demoRules': 'Zasady badania łóżka: {system}. Dodaj "prawa" do adresu, żeby spróbować innego.',
  'city.messages': 'Notatki',
  'city.rules': 'System gry',
  'city.rulesNarrative': 'Nie ma reguł: miasto jako historia. Wybierz system, który będzie widział wszystkich w jego liczbach.',
  'city.statsFor': 'Numery dla',
  'city.sparTitle': '/Wykonywanie walki /',
  'city.sparA': 'Pierwszy bojownik',
  'city.sparB': 'Drugi bojownik',
  'city.sparVs': 'w stosunku do',
  'city.sparRun': 'Walka',
  'city.sparNote': 'Nikt w mieście nie został ranny.',
  'city.sparRound': 'Okrągłe {n}.',
  'city.zoomIn': 'Zwiększ',
  'city.pivot.left': 'Obróć widok w lewo',
  'city.pivot.right': 'Obróć widok w prawo',
  'city.pivot.north': 'Zwróć na północ',
  'city.zoomOut': 'Zwiększ się .',
  'city.centre': '/W centrum na mnie.',
  'city.followOn': 'Idź dalej.',
  'city.followOff': 'Idź dalej.',
  'city.followOnHint': 'Kamera cię śledzi.',
  'city.followOffHint': 'Uderz mnie, żeby wrócić do siebie.',
  'city.minimapShow': 'Pokaż mapę',
  'city.minimapHide': 'Ukryj mapę',
  'city.minimapOpen': 'Na mapie miasta, aby ją otworzyć większą.',
  'city.minimapWalk': 'Na mapie miasta.',
  'city.minimapSmall': 'Zmniejsz mapę',
  'city.minimapHint': 'Wciskaj, żeby tam iść.',
  'city.chatter.morning.1.a': 'Świeży chleb w piecach w rogu, jeśli się spieszysz.',
  'city.chatter.morning.1.b': '- Poczułem go na dwie ulice dalej.',
  'city.chatter.morning.2.a': 'Wstałeś wcześnie.',
  'city.chatter.morning.2.b': 'Dzwonki zawsze mnie budzą.',
  'city.chatter.morning.3.a': 'Czy wózki weszły przez bramę?',
  'city.chatter.morning.3.b': 'Trzy z nich, a jeden stracił koło na moscie.',
  'city.chatter.morning.4.a': 'Dziś rano zimno.',
  'city.chatter.morning.4.b': 'Mgła rzeki wypali do południa.',
  'city.chatter.morning.5.a': 'Gdzie idziesz?',
  'city.chatter.morning.5.b': 'Rynek, zanim dobre jabłka znikną.',
  'city.chatter.afternoon.1.a': 'Zajęty dzień w sklepach.',
  'city.chatter.afternoon.1.b': 'Jestem zbyt zajęty.',
  'city.chatter.afternoon.2.a': 'Widziałeś dziś ten brązownik?',
  'city.chatter.afternoon.2.b': 'Zeszła do wody godzinę temu.',
  'city.chatter.afternoon.3.a': 'Słońce jest dziś miłe.',
  'city.chatter.afternoon.3.b': 'Nadchodzi deszcz, czuję to w kolanach.',
  'city.chatter.afternoon.4.a': 'Co sprzedawca ryb chciał dla orzech?',
  'city.chatter.afternoon.4.b': 'Kupiłem zamiast tego orzechy.',
  'city.chatter.afternoon.5.a': 'Czy to nowy wózek?',
  'city.chatter.afternoon.5.b': 'Koła wciąż krzyczą jak dawna.',
  'city.chatter.evening.1.a': 'Wracasz już do domu?',
  'city.chatter.evening.1.b': 'Kolacja sama się nie gotuje.',
  'city.chatter.evening.2.a': 'Światła wchodzą.',
  'city.chatter.evening.2.b': 'Więc znów się spóźnię.',
  'city.chatter.evening.3.a': 'Będziesz dziś w tawernie?',
  'city.chatter.evening.3.b': 'Jeśli moja żona mi pozwoli, tak.',
  'city.chatter.evening.4.a': 'Długie dni.',
  'city.chatter.evening.4.b': 'Wszystkie są w tym czasie roku.',
  'city.chatter.evening.5.a': 'Zamknijcie okna dziś wieczorem.',
  'city.chatter.evening.5.b': 'W każdym razie wiatr ich trzęsie.',
  'city.chatter.night.1.a': 'Kto tam idzie?',
  'city.chatter.night.1.b': 'Odłóż tę latarkę.',
  'city.chatter.night.2.a': 'Powinieneś spać.',
  'city.chatter.night.2.b': 'Ty też powinieneś, przyjacielu.',
  'city.chatter.night.3.a': 'Słyszałeś coś przy wodzie?',
  'city.chatter.night.3.b': 'Zawsze są kotami.',
  'city.chatter.night.4.a': 'Cicha noc.',
  'city.chatter.night.4.b': 'Trzymajmy to tak.',
  'city.chatter.any.1.a': 'Słyszałaś wiadomości?',
  'city.chatter.any.1.b': 'Zawsze są wiadomości.',
  'city.chatter.any.2.a': 'Dzień dobry.',
  'city.chatter.any.2.b': 'I dla ciebie.',
  'city.chatter.any.3.a': 'Mój kuzyn przysięga, że stara wieża jest nawiedzona.',
  'city.chatter.any.3.b': 'Twój kuzyn przysięga wiele rzeczy.',
  'city.chatter.any.4.a': 'Ceny wciąż rosną.',
  'city.chatter.any.4.b': 'A moja pensja staje na miejscu.',
  'city.chatter.any.5.a': 'Uważaj na tę lodowkę.',
  'city.chatter.any.5.b': 'Za późno.',
  'city.chatter.any.6.a': 'Czy to ten cudzoziemiec, o którym wszyscy mówią?',
  'city.chatter.any.6.b': 'Nie patrz na mnie, to niegrzeczne.',
  'city.chatter.any.7.a': 'Jak się czuje twoja matka?',
  'city.chatter.any.7.b': 'Wróciła do mnie, żeby mnie wyrzekać.',
  'city.chatter.any.8.a': 'Jestem ci winien drinka, prawda?',
  'city.chatter.any.8.b': 'Dwa, według mojej liczby.',
  'city.inventory.title': 'Twoja paczka.',
  'city.inventory.subtitle': 'Montkelian satchel',
  'city.inventory.close': 'Zamknij paczkę.',
  'city.inventory.tabs': 'Sekcje opakowania',
  'city.inventory.tab.inventory': 'Inwentaryzacja',
  'city.inventory.tab.journal': 'Dziennik',
  'city.inventory.tab.map': 'Mapa',
  'city.inventory.empty': 'Wszystko, co znajdziesz podczas podróży, będzie w tych kieszeniach.',
  'city.inventory.slots': 'Kieszeni',
  'city.inventory.slotEmpty': 'Kieszonkowe {n}, puste',
  'city.inventory.slot.headgear': 'Głowa',
  'city.inventory.slot.helmet': 'Hełm',
  'city.inventory.slot.hat': 'Kapelusz',
  'city.inventory.slot.hood': 'Kapusta',
  'city.inventory.slot.amulet': 'Amuleta',
  'city.inventory.slot.cloak': 'Płaszcz',
  'city.inventory.slot.tabard': 'Tabard',
  'city.inventory.slot.pelt': 'Płód',
  'city.inventory.slot.armor': 'Broń',
  'city.inventory.slot.plate': 'Płyta',
  'city.inventory.slot.robe': 'Robe',
  'city.inventory.slot.jerkin': 'Głupiec.',
  'city.inventory.slot.hide': 'Ukryj się',
  'city.inventory.slot.girdle': 'Girdle',
  'city.inventory.slot.belt': 'Pas',
  'city.inventory.slot.bracers': 'Wyrzutki',
  'city.inventory.slot.gloves': 'Głownie',
  'city.inventory.slot.mainHand': 'Główna ręka',
  'city.inventory.slot.offHand': 'Nie w porządku.',
  'city.inventory.slot.twoHand': 'Obie ręce.',
  'city.inventory.slot.sword': 'Miecz',
  'city.inventory.slot.shield': 'Tarcza',
  'city.inventory.slot.staff': 'Pracownicy',
  'city.inventory.slot.focus': 'Skupić się',
  'city.inventory.slot.ring': 'Pierścień',
  'city.inventory.slot.leggings': 'Włosy',
  'city.inventory.slot.greaves': 'Greaves',
  'city.inventory.slot.boots': 'Szuflady',
  'city.inventory.item.sword': 'Miecz',
  'city.inventory.item.shield': 'Tarcza',
  'city.inventory.item.knife': 'Noż',
  'city.inventory.item.axe': 'Szybko',
  'city.inventory.item.tabard': 'Tabard',
  'city.inventory.item.cape': 'Przylądek',
  'city.inventory.item.ring': 'Pierścień',
  'city.inventory.class.default': 'podróżnik',
  'city.inventory.class.fighter': 'wojownik',
  'city.inventory.class.paladin': 'Paladin',
  'city.inventory.class.berserker': 'Berserker',
  'city.inventory.class.wizard': 'czarodzieja',
  'city.inventory.class.rogue': 'niegodziwy',
  'city.inventory.slotFree': 'Puste',
  'city.inventory.gear': 'Co nosisz?',
  'city.inventory.view': 'Pokaż',
  'city.inventory.viewGear': 'Wykorzystane',
  'city.inventory.viewPockets': 'Kieszeni',
  'city.inventory.avatarHint': 'Wybierz inny avatar z menu pod "Avatar".',
  'city.inventory.soon.journal': 'Twoje dzienniki są teraz puste.',
  'city.inventory.soon.map': 'Twoja złożona mapa zostanie przechowywana tutaj, oznaczona miejscami, w których byłaś.',
  'city.inventory.hint': 'Uderz się, aby otworzyć opakowanie',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Wybierz swój avatar.',
  'city.avatar.robot': 'Robot',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladin',
  'city.avatarCloth': 'Tkaniny',
  'city.avatarClothHint': '/W czasie ruchu /podręczają się kapki i tabardy.',
  'city.soundOn': 'Włącz dźwięk',
  'city.soundOff': 'Wyłącz dźwięk',
  'city.musicOn': 'Zagraj muzykę',
  'city.musicOff': 'Przestań muzykę.',
  'city.walkSpeed': 'Szybkość',
  'city.walkSpeedLabel': 'Prędkość chodzenia',
  'city.walkSpeedValue': '{n}x',
  'city.me': '- Ja ...',
  'city.quality': 'Jakość',
  'city.qualityAuto': 'Automatyczny ({tier})',
  'city.tier.low': 'Niskie',
  'city.tier.medium': 'Średnie',
  'city.tier.high': 'Wysoki',
  'city.robot.keys': 'Klucze robotów',
  'city.robot.title': 'Klucze robotów',
  'city.robot.intro': 'Naciskaj klucz lub kliknij tutaj, a twój robot wyświetla go dla wszystkich w pobliżu.',
  'city.robot.close': '/Zbliża się',
  'city.robot.jumpNote': 'W powietrzu ponownie naciśnij Space, aby podwoić skok.',
  'city.robot.spellNote': 'W trybie zaklęcia 1, 2 i 3 rzuca się zamiast ataku.',
  'city.robot.climbNote': 'W górę i w dół można wspinać się po schodach, drabinie, szczenięcie lub kanapce drenowej, które są najbliższe.',
  'city.robot.walkNote': 'W, A, S i D idą na północ, zachód, południe i wschód krok po kroku.',
  'city.robot.walk.north': 'Idź na północ.',
  'city.robot.walk.west': 'Idź na zachód',
  'city.robot.walk.south': 'Idź na południe.',
  'city.robot.walk.east': 'Idź na wschód.',
  'city.stairs.label': 'Weź schody .',
  'city.stairs.up': 'W górę .',
  'city.stairs.down': 'W dół.',
  'city.stairs.goUp': 'Idź na piętro .',
  'city.stairs.goDown': 'Idź na podłogę.',
  'city.robot.toggleNote': 'Tryb broni, tryb zaklęcia, Sneak, Dance i Fall Down pozostają na nim, dopóki nie naciśnij ich ponownie.',
  'city.robot.typing': 'Kluczyki nic nie robią, kiedy typisz w pudełku.',
  'city.robot.inSpell': 'Mód zaklęcia: {act}',
  'city.robot.otherwise': 'W przeciwnym razie: {act}',
  'city.robot.pad': 'Działania',
  'city.robot.padShow': 'Wyświetlanie płytu akcji',
  'city.robot.padHide': 'Ukryj płytkę akcji',
  'city.robot.padTouch': '(dla ekranu dotykowego)',
  'city.robot.noLadder': 'Nie ma w pobliżu schodów.',
  'city.robot.act.jump': 'Skocz .',
  'city.robot.act.double-jump': 'Podwójny skok',
  'city.robot.act.dodge': 'Uciekaj .',
  'city.robot.act.block': 'Zablokować lub bronić',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Tryb broni',
  'city.robot.act.spell-mode': 'Tryb zaklęcia',
  'city.robot.act.slash': 'Slash',
  'city.robot.act.thrust': 'Napęd',
  'city.robot.act.flurry': '- Nie wiem.',
  'city.robot.act.cast': 'Wyróżnienie',
  'city.robot.act.cast-spell': 'Zaklęcie',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': 'Kaczka.',
  'city.robot.act.sneak': 'Sneak',
  'city.robot.act.sing': 'Śpiewaj',
  'city.robot.act.dance': 'Taniec',
  'city.robot.act.barf': 'Wykręty',
  'city.robot.act.fall': 'Wpadnij lub wstań.',
  'city.robot.act.climb-up': 'Wzniesić się .',
  'city.robot.act.climb-down': 'Wsiadaj.',
  'city.robot.act.hurt': 'Złap hit .',
  'city.robot.act.kneel': 'Kolana i stanąć',
  'city.robot.act.bow': 'Łuk',
  'city.robot.act.cheer': 'Żegnajcie zwycięstwo',
  'city.panelShow': 'Panel wyświetlania',
  'city.phone.menu': 'Menu',
  'city.phone.close': 'Menu zamknięte',
  'city.phone.view': 'Mapa',
  'city.phone.sound': 'Głos i tempo',
  'city.phone.people': 'Znajdź kogoś.',
  'city.phone.more': 'Wszystko inne.',
  'city.phone.hint': 'Uderz ziemię, żeby chodzić. Uderz osobę, żeby porozmawiać.',
  'city.phone.gotIt': 'Rozumiem.',
  'city.panelHide': 'Panel ukrywający',
  'city.canvasLabel3d': 'Mapa {city} Widać go z góry pod kątem. Przeciągnij, aby spojrzeć wokół, przycisnąć lub przewiesić, aby zwiększyć, naciśnij, aby chodzić lub porozmawiać.',
  'city.dock.label': 'Ludzie do znalezienia',
  'city.dock.go': 'Idź do niego. {name}',
  'city.dock.walking': 'Idąc do {name}',
  'city.dock.toPlace': 'Idąc do {name} w {place}',
  'city.dock.cancel': 'Pociskaj ziemię, żeby się zatrzymać.',
  'city.rigDebug.open': 'Odbudowa sposobu {name} ruchy',
  'city.rigDebug.title': 'Odbudowa urządzenia: {name}',
  'city.rigDebug.close': '/Zbliża się',
  'city.rigDebug.move': 'Ruszaj się',
  'city.rigDebug.facing': 'W obliczu',
  'city.rigDebug.allMoves': 'Wszystkie ruchy',
  'city.rigDebug.allFacings': 'Wszystkie obszary',
  'city.rigDebug.cycling': 'Rowery, {s}s każdy',
  'city.rigDebug.play': 'Zagraj',
  'city.rigDebug.pause': 'Przestań',
  'city.rigDebug.back': 'Wracaj w jedną ramę.',
  'city.rigDebug.forward': 'Krok w przód jeden ramy',
  'city.rigDebug.speed': 'Szybkość',
  'city.rigDebug.hint': 'Zrób pauzę, a następnie kliknij na zewnątrz lub naciśnij Escape, aby zamknąć.',
  'city.rigDebug.anim.idle': 'Nie działa.',
  'city.rigDebug.anim.walk': 'Chodź',
  'city.rigDebug.debug': 'Odbudowa',
  'city.rigDebug.viewLabel': 'Widok',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Isometryczne',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'w twarzy {dir}',
  'city.rigDebug.cell': 'rząd {row}, ramy {col}',
  'city.rigDebug.loading': 'obciążenie',
  'city.rigDebug.clip': 'Klip',
  'city.rigDebug.allClips': 'Wszystkie klipy',
  'city.rigDebug.noClips': 'Bez klipów',
  'city.rigDebug.layers': 'Pokaż',
  'city.rigDebug.show.model': 'Model',
  'city.rigDebug.show.bones': 'Kości',
  'city.rigDebug.show.pieces': 'Części',
  'city.rigDebug.boneCount': '{n} kości',
  'city.rigDebug.no3d': 'Widok 3D nie mógł się uruchomić na tym ekranie.',
  'city.rigDebug.hint3d': 'Przeciągnij, aby odwrócić kamerę, zatrzymaj się na krok od kręgu, naciśnij na zewnątrz lub naciśnij Escape, aby zamknąć.',
  'city.rigDebug.standIn': '{name} jest wyświetlany na {body} ciało tutaj, dopóki jej własne nie będzie gotowe.',
  'city.rigDebug.archive': 'Archiwum',
  'city.rigDebug.archivePose': 'Poprzedni przegląd pozycji: zobacz jak {name} ruchy',
  'city.pose.open': 'Zobacz jak. {name} ruchy',
  'city.pose.robot': 'Ty (robot zastępca)',
  'city.pose.you': 'Ty...',
  'city.pose.see': 'Widzę jak się poruszają.',
  'city.pose.youTitle': 'Jak się poruszasz',
  'city.pose.openYou': 'Zobacz jak się poruszasz.',
  'city.pose.title': 'Jak to zrobić? {name} ruchy',
  'city.pose.allTitle': 'Wszystkie pozycje',
  'city.pose.all': 'Pokaż wszystkie pozycje',
  'city.pose.one': 'Tylko ... {name}',
  'city.pose.close': '/Zbliża się',
  'city.pose.hint': 'Wykop się na zewnątrz , aby zamknąć .',
  'city.pose.loading': 'Ładowanie',
  'city.pose.anim.idle': 'Nie działa.',
  'city.pose.anim.walk': 'Chodź',
  'city.pose.anim.talk': 'Rozmawiaj.',
  'city.pose.anim.sit': 'Siadaj.',
  'city.pose.anim.run': 'Uciekaj .',
  'city.pose.drag': 'Przeciągnij do obrotu',
  'city.pose.gait': 'Ruch',
  'city.pose.model': '{name} w 3D',
  'city.pose.dir.SW': 'w kierunku południowo-zachodnim',
  'city.pose.dir.SE': 'w kierunku południowo-wschodnim',
  'city.pose.dir.NE': 'w kierunku północnego wschodu',
  'city.pose.dir.NW': 'w kierunku północno-zachodnim',
  'city.demoLink': 'Otwórz demo renderera',
  'city.demoTitle': 'Demonstracja renderera',
  'city.demoNote': 'Lokalny przegląd 3D miasta z walkerami.',
  'city.demoTime': 'Czas dnia',
  'city.demoSeason': 'Sezon',
  'city.demoPlay': '/Wykorzystaj zegarek.',
  'city.demoPause': 'Zatrzymaj zegar.',
  'city.demoTower': 'Wieża testowa',
  'city.demoTowerNote': 'Cztery piętra budynku, w którym można sprawdzić, co widać wewnątrz.',
  'city.demoGoTower': 'Chodź do wieży.',
  'city.demoFloor': 'Podłogę: {floor}',
  'city.demoFloor0': 'Poziom',
  'city.demoFloor1': 'Dwa',
  'city.demoFloor2': 'Trzecie',
  'city.demoFloor3': 'Czwarta',
  'city.demoFloor4': 'Dach',
  'city.demoWindow': 'Okno trzeciego piętra',
  'city.demoRoom': 'Pokój wewnętrzny 3. piętra',
  'city.demoUp': 'Na piętrze',
  'city.demoDown': 'Na podłodze',
  'city.makeWay.polite': 'Przepraszam.',
  'city.makeWay.gruff': 'Hej, uważaj, gdzie idziesz.',
  'city.makeWay.immovable': 'Nie ruszę się.',
  'city.makeWay.busy': 'Uważaj na drogę.',
  'cascade.seoTitle': 'Odbudowaczka kaskadowa',
  'cascade.title': 'Odbudowaczka kaskadowa',
  'cascade.intro': 'Każda prędkość, która kształtuje tworzy sztukę, rozmieszczona jako dwa drzewa genealogiczne. Strona stylu biegnie od systemu aż do dyrektora sztuki. Strona dziedzicza jest całą taksonomią, od każdego szczotka korzenia aż do gatunku i linii, które siedzą na nich. Otwórz każdy wiersz, aby przeczytać jego pełny tekst.',
  'cascade.readOnly': 'Nic na tym ekranie nie może zmienić polecenia.',
  'cascade.fetchedAt': 'Przeczytaj z API treści w {time}',
  'cascade.refresh': 'Przeczytaj jeszcze raz.',
  'cascade.loading': 'Czytając obie kaskady...',
  'cascade.error': 'Nie mogłem przeczytać kaskady z API treści.',
  'cascade.forbidden': 'Ten ekran jest dla administratorów witryny. Konto jest zalogowane, ale nie ma roli administratora.',
  'cascade.style.title': 'Kaskady stylu',
  'cascade.style.subtitle': 'System, wydawca, linia produktów, ustawienie, rodzaj mediów, książka i dyrektor artystyczny.',
  'cascade.style.focus': 'Idź za łańcuchem',
  'cascade.style.counts': '{nodes} wiersze stylu, {edges} połączenia, {media} szablony mediów',
  'cascade.taxa.title': 'Kaskada spadkobierców',
  'cascade.taxa.subtitle': 'Każdy węzeł dodaje swój własny prompto do wszystkiego, co odziedziczy z węzłów powyżej niego.',
  'cascade.taxa.group': 'Grupa promptowa',
  'cascade.taxa.find': 'Znajdź takson lub linię',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, nazwisko liniowe...',
  'cascade.taxa.counts': '{taxa} taksy, {prompts} takson prompts, {lineages} linie',
  'cascade.taxa.shardCounts': '{taxa} tax, {prompts} promptowych rzędów',
  'cascade.taxa.truncated': 'API zawartości ograniczyła listę zaproszeń tego fragmentu, więc może tu brakować kilku rzędów.',
  'cascade.taxa.emptyShards': 'Szczątki bez taksówek: {names}',
  'cascade.taxa.orphans': 'Rodzaje wskazujące na takson, który nie znajduje się w żadnym drzewie',
  'cascade.taxa.noOwn': 'Nie ma żadnych samych wskazówek dla tej grupy.',
  'cascade.taxa.inherits': 'Dziedzictwo z góry',
  'cascade.taxa.inheritsNothing': 'Nic dziedzicznego.',
  'cascade.taxa.through': 'Połączone przez ten węzeł',
  'cascade.taxa.lineages': 'Rodzaje tego gatunku',
  'cascade.level.system': 'System',
  'cascade.level.publisher': 'Wydawca',
  'cascade.level.product_line': 'Linia produktów',
  'cascade.level.setting': 'Ustawienie',
  'cascade.level.media': 'Rodzaj mediów',
  'cascade.level.book': 'Książka',
  'cascade.level.art_director': 'Reżyser sztuki',
  'cascade.empty.system': 'Nie ma w tym łańcuchu żadnych systemów.',
  'cascade.empty.publisher': 'Nie ma jeszcze linii w stylu wydawcy.',
  'cascade.empty.product_line': 'Nie ma linii stylu produktu w tym łańcuchu.',
  'cascade.empty.setting': 'Nie ma ustawionych linii stylu w tym łańcuchu.',
  'cascade.empty.media': 'Nie ma zastosowania do tego łańcucha szablonów typu media.',
  'cascade.empty.book': 'Nie ma żadnego stylu książek, który by zawiesił na tej scenie.',
  'cascade.empty.art_director': 'Żaden dyrektor artystyczny nie jest związany z tą łańcuchem.',
  'cascade.missing': 'Brak poziomu',
  'cascade.others': 'Pozostałe wiersze na tym poziomie ({count})',
  'cascade.mediaSpeciesNote': '{count} szablony gatunków są wyświetlane po stronie dziedzictwa, pod ich liniami.',
  'cascade.field.id': 'id',
  'cascade.field.scope': 'zakres',
  'cascade.field.scopeId': 'identyfikacja zakresu',
  'cascade.field.group': 'grupa',
  'cascade.field.mediaType': 'rodzaj mediów',
  'cascade.field.prompt': 'prędkość',
  'cascade.field.negative': 'Utrzymanie',
  'cascade.field.defaults': 'niewypełnione',
  'cascade.field.refs': 'obrazy odniesienia',
  'cascade.field.chars': '{count} znaków',
  'cascade.field.empty': 'puste',
  'cascade.facet.art_direction': 'Głąb',
  'cascade.facet.art_direction_character': 'Charakter',
  'cascade.facet.art_direction_scene': 'Scena',
  'cascade.facet.art_direction_interface': 'Interfejs',
  'cascade.facet.art_direction_cartography': 'Kartografia',
  'cascade.facet.art_direction_audiobook': 'Książka dźwiękowa',
  'cascade.facet.art_direction_movie': 'Film',
  'cascade.facet.art_direction_short': 'Krótkie',
  'cascade.facet.art_direction_tvshow': 'Program telewizyjny',
  'cascade.composed.title': 'Złożone z: {name}',
  'cascade.composed.layers': 'Sławy, szerokie do wąskie',
  'cascade.composed.preview': 'Powtórzenie obrazu złożonego',
  'cascade.composed.previewNote': 'Zgromadzone na tym ekranie z wierszy powyżej w kolejności kaskadowej: podstawa stylu, faseta znaków, szablony mediów, cechy taksonowe, następnie linia drukowania generator doda w kodzie.',
  'cascade.composed.negative': 'Kompozytowe ujemne',
  'cascade.composed.fromCode': 'dodane w kodzie, nie przechowywane w żadnym rzędzie',
  'cascade.flags.duplicates': 'Powiedziałem dwa razy.',
  'cascade.flags.conflicts': 'Negatywne terminy, które pojawiają się również w instrukcji',
  'cascade.flags.none': 'Bez powtarzających się zdań i negatywnych terminów, które są w sprzeczności z instrukcją.',
  'cascade.flags.in': 'w {sources}',
  'cascade.source.styleCore': 'kształt',
  'cascade.source.styleCharacter': 'Facet charakteru stylu',
  'cascade.source.media': 'szablon mediów, {scope}',
  'cascade.source.taxon': 'takson {rank} {value}',
  'cascade.source.printSafe': 'linia drukowana (kod)',
  'cascade.rank.domain': 'domena',
  'cascade.rank.kingdom': 'królestwo',
  'cascade.rank.phylum': 'filum',
  'cascade.rank.class': 'klasy',
  'cascade.rank.ordem': 'kolejność',
  'cascade.rank.family': 'rodzina',
  'cascade.rank.genus': 'rodzaj',
  'cascade.rank.species': 'gatunki',
  'cascade.rank.shard': 'szczotki',
}
